/* LAS DERIVACIONES DE AVISOS DE RUTA NO SON DE LA TICKETERA DE TODOS (Igna,
 * 23/10/2026: «no deberían estar en nuestra ticketera y NUNCA deberían
 * llegarnos a nosotros porque nosotros no manejamos eso»). Un «Foto de un
 * chofer: …» es de la persona a la que se le derivó y de su sector: la ven
 * ella, quien la derivó y los de esa área. La RLS deja leer más (quien atiende
 * el área por permiso), así que el corte se hace acá, con el área REAL de la
 * sesión (`mi_area_ticket`, en services/tickets), no con los permisos. */
export const ORIGEN_DERIVACION = "avisos_ruta";

export function laVeo(t, yo, miArea) {
  if (t?.origen !== ORIGEN_DERIVACION) return true;
  const m = (yo || "").toLowerCase();
  return (
    (!!m && (t.asignado_a || "").toLowerCase() === m) ||
    (!!m && (t.abierto_por || "").toLowerCase() === m) ||
    (!!miArea && t.area === miArea)
  );
}
